import { useCallback } from "react"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_verifyHealthInformationInput,
  chVerifyHealthInformationMutation,
  chVerifyHealthInformationMutation$data,
} from "@/modules/patients/services/ch/__generated__/chVerifyHealthInformationMutation.graphql"
import { chVerifyHealthInformationMutation as chMutation } from "@/modules/patients/services/ch/chVerifyHealthInformationMutation"
import {
  De_verifyHealthInformationInput,
  deVerifyHealthInformationMutation,
  deVerifyHealthInformationMutation$data,
} from "@/modules/patients/services/de/__generated__/deVerifyHealthInformationMutation.graphql"
import { deVerifyHealthInformationMutation as deMutation } from "@/modules/patients/services/de/deVerifyHealthInformationMutation"

const useVerifyHealthInformation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutationWithErrorDialog<chVerifyHealthInformationMutation & deVerifyHealthInformationMutation>(
    mutation,
  )

  return useCallback(
    (
      input: De_verifyHealthInformationInput & Ch_verifyHealthInformationInput,
      onCompleted?: (res: chVerifyHealthInformationMutation$data & deVerifyHealthInformationMutation$data) => void,
    ) => {
      commit({
        variables: {
          input,
        },
        onCompleted,
      })
    },
    [commit],
  )
}

export { useVerifyHealthInformation }
